// extracted by mini-css-extract-plugin
export default {"container":"CopyField_container__FJjBw","label":"CopyField_label__dX2Fs","input":"CopyField_input__zxT1J","icon":"CopyField_icon__SH8Ae","content":"CopyField_content__T5vC2"};